import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { StyledEngineProvider } from '@mui/material/styles';

import { setLoggerConfig } from 'packages/ui-components/utils/DupontLogger/logger.conf';

import Chatbot from './Chatbot';
//import reportWebVitals from './reportWebVitals';
import ChatbotStore from './store';

import './index.scss';

setLoggerConfig({ isLogToConsole: process.env.REACT_APP_ENVIRONMENT !== 'prod' });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={ChatbotStore}>
    <Router>
      <StyledEngineProvider injectFirst>
        <Chatbot />
      </StyledEngineProvider>
    </Router>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
//reportWebVitals(console.log);
